//funzioni per gestire la pagina di manutenzione

import axios from 'axios'

//API per auth
function getUrlMaintenance() {
  var url = '/SCTProfessional/default/call/json/get_maintenance';
  /*
   if (process.env.NODE_ENV === 'development') {
     url = 'http://localhost:8000' + url;
   }
   */
  return url;
}

export default {
  //restituisce tutte le informazioni della pagina di manutenzione
  getMaintenance() {
    return axios
      .get(getUrlMaintenance())
      .then(response => {
        return response.data;
      })
  },

}
